import { createContext } from 'react';
import type { ContentfulArticleSearchResponse, GetArticlePageParams } from 'autogen/swagger/all';

type TypeArticleSearchResponseContextWrapper = {
    data?: ContentfulArticleSearchResponse;
    updateArticlePage: (params: Partial<GetArticlePageParams>, appendArticles?: boolean) => Promise<void>;
};

const ArticleSearchResponseContext = createContext<TypeArticleSearchResponseContextWrapper | undefined>(undefined);

export default ArticleSearchResponseContext;
